import appComponents from '@/router/components';

const routes = [
    {
        path: '/dashboard/register',
        name: 'register',
        components: {
            Content: appComponents.access_control.unauthenticated.register,
        },
        meta: {
            title: 'Register',
        },
    },
    {
        path: '/dashboard/register/email-verification',
        name: 'register.email.verification',
        components: {
            Content: appComponents.access_control.unauthenticated.verification,
        },
        meta: {
            title: 'Verification',
        },
    },

    {
        path: '/dashboard/redeem',
        name: 'redeem',
        components: {
            Content: appComponents.access_control.unauthenticated.redemption,
        },
        meta: {
            title: 'Redeem Code',
        },
    },

    {
        path: '/dashboard/redeem/verification',
        name: 'redeem.verification',
        components: {
            Content: appComponents.access_control.unauthenticated.redemption_verify,
        },
        meta: {
            title: 'redeem Verification',
        },
    },

    {
        path: '/dashboard/login',
        name: 'login',
        components: {
            Content: appComponents.access_control.unauthenticated.login,
        },
        meta: {
            title: 'Login',
        },
    },

    {
        path: '/dashboard/forgot-password',
        name: 'forgotPassword',
        components: {
            Content: appComponents.access_control.unauthenticated.forgot,
        },
        meta: {
            title: 'Forget Password',
        },
    },

    {
        path: '/dashboard/reset-password/:token',
        name: 'resetPassword',
        components: {
            Content: appComponents.access_control.unauthenticated.reset,
        },
        meta: {
            title: 'Reset Password',
        },
    },

    {
        path: '/dashboard',
        name: 'app.dashboard',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.access_control.dashboard,
        },
        meta: {
            title: 'Dashboard',
            required_auth: true,
            required_permission: false,
        },
    },

    {
        path: '/dashboard/profile',
        name: 'profile',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.access_control.account.profile,
        }, meta: {
            title: 'Profile',
            required_auth:true,
            required_permission:false,
            permissions:[]
        },
    },

    {
        path: '/dashboard/change-password',
        name: 'change.password',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.access_control.account.changePassword,
        },
        meta: {
            title: 'Change Password',
            required_auth:true,
            required_permission:false,
            permissions:[]
        },
    },

    {
        path: '/dashboard/admin/users',
        name: 'app.admin.users.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.access_control.admin.users,
        },
        meta: {
            title: 'Users',
            required_auth: true,
            required_permission: true,
            permissions: ['view_users']
        },
    },

    {
        path: '/dashboard/admin/permissions',
        name: 'app.admin.permissions.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.access_control.admin.permissions,
        },
        meta: {
            title: 'Permissions',
            required_auth: true,
            required_permission: true,
            permissions: ['view_permissions']
        },
    },

    {
        path: '/dashboard/admin/roles',
        name: 'app.admin.roles.list',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.access_control.admin.roles,
        },
        meta: {
            title: 'Roles',
            required_auth: true,
            required_permission: true,
            permissions: ['view_roles']
        },
    },

    {
        path:'/dashboard/:path(.*)',
        name: 'app.notfound',
        components: {
            Content: appComponents.access_control.layouts.index,
        },
        meta: {
            title: 'Not Found',
            required_auth: true,
        },
    },
];


export default routes;

